export default "__VITE_ASSET___Ov5K7df__"